import React from "react";

// Components
import Navbar from "../containers/Home/Navbar";
import LoginForm from "../containers/Login/LoginForm";

//
import useAuth from "../utils/hooks/useAuth";

const Login = () => {
  useAuth({
    authRequired: false,
    redirectTo: "/editor",
  });

  return (
    <>
      <Navbar />
      <main className="landing-home content px-0 px-md-3">
        <div className="container-fluid">
          <div className="row">
            <div className="col bg-white bg-login m-0 m-md-5 p-0 p-md-4">
              <LoginForm />
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
